import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { PrimeThemeService } from '../../../themes/prime-theme.service';

@Component({
  selector: 'app-call-card',
  templateUrl: './call-card.component.html',
  styleUrls: ['./call-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CallCardComponent {
  // Signal-based inputs
  bodyObject = input<any>();
  dateTimeLocale = input<string>();
  currentTabIndex = input<string>();

  // Signal-based output
  onLaunchDialer = output<any>();

  constructor(public primeThemeService: PrimeThemeService) {}

  launchDialer($event: Event, tel: string, title: string, behavior: any) {
    this.onLaunchDialer.emit({
      $event: $event,
      tel: tel,
      title: title,
      behavior: behavior
    });
  }
}
